// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2uq7E","name":"Header_name__3vFQN","birthday":"Header_birthday__v1hXP","skeleton":"Header_skeleton__1dh2a"};